import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PageHeader, Layout, Tabs, Spin, Typography } from 'antd';
import WorkspaceMetrics from './WorkspaceMetrics';
import GridMetrics from './grid_metrics';
import { Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import './metrics.css';

const { TabPane } = Tabs;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: 'workspace_metrics',
      loading: true,
      teamDataLoading: false,
      gridWorkSpace: false,
      updateDashBoard: '',
      updateGridMetrics: '',
      gridInitial: '',
      lastUpdatedGrid: '',
      lastUpdatedWorkSpace: '',
    };
    this.getData = this.getData.bind(this);
    this.getGridInitialData = this.getGridInitialData.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.wId !== prevProps.match.params.wId) {
      this.setState({ activeKey: 'workspace_metrics', teamDataLoading: true });
    }

    if (prevProps.team != this.props.team) {
      this.setState({ activeKey: 'workspace_metrics', teamDataLoading: false });
    }
  }

  handleTabChange = () => {
    if (this.state.activeKey === 'workspace_metrics') {
      this.setState({ activeKey: 'grid_metrics' });
    } else {
      this.setState({ activeKey: 'workspace_metrics' });
    }
  };
  onClick = () => {
    if (this.state.activeKey === 'workspace_metrics') {
      this.state.updateDashBoard();
    } else this.state.updateGridMetrics();
  };
  getData(val) {
    this.setState({ loading: true });
    if (val && val[0] !== 'Invalid date')
      if (this.state.activeKey === 'workspace_metrics') {
        this.setState({ lastUpdatedWorkSpace: val[0] });
      } else {
        this.setState({ lastUpdatedGrid: val[0] });
      }
    this.setState({ loading: false });
  }
  getGridInitialData(val) {
    if (val) {
      this.setState({ lastUpdatedGrid: val });
    }
  }

  render() {
    const { team, isWorkspaceAdmin } = this.props;
    const { teamDataLoading } = this.state;
    let isGridWorkspace,
      loading = true;
    if (team.id) loading = false;
    if (
      team.bot &&
      team.bot.meta &&
      team.bot.meta.enterprise &&
      team.bot.meta.enterprise.id
    )
      isGridWorkspace = true;

    return (
      <>
        <Layout
          style={{
            height: '100vh',
            // overflow: 'auto',
            marginLeft: 0,
            // padding : '0px 24px 24px 24px'
            // padding: '16px 24px',
          }}
        >
          <div /* className='header' */ /* style={{ padding: '16px 16px 16px 24px' }} */
          >
            <PageHeader
              style={
                isGridWorkspace
                  ? { padding: '22px 24px 5px 24px' }
                  : { padding: '22px 24px 10px 24px' }
              }
              title={
                <>
                  {/* <span style={{ marginRight: 8 }}>Metrics</span> */}
                  <Typography.Title level={3} style={{ fontWeight: 'normal' }}>
                    Troopr Home
                  </Typography.Title>
                  {/* <Button
                    type='primary'
                    onClick={this.onClick}
                    icon={<ReloadOutlined />}
                  >
                    Refresh
                  </Button> */}
                </>
              }
              subTitle={
                <div style={{ marginBottom: '4.5%' }}>
                  {isWorkspaceAdmin
                    ? !this.state.loading
                      ? `Last updated at ${this.state.activeKey === 'workspace_metrics'
                        ? this.state.lastUpdatedWorkSpace
                        : this.state.lastUpdatedGrid
                      }`
                      : ''
                    : ''}
                </div>
              }
              extra={
                <> <Button
                  type='primary'
                  onClick={() => {
                    this.props.history.push(`/${this.props.match.params.wId}/settings?view=members`);
                  }}
                  style={{ marginRight: 12 }}
                >
                  Invite people
                </Button>
                  {team && team.refreshButtonForTestingMetrics ? (
                    <Button
                      type='primary'
                      onClick={this.onClick}
                      icon={<ReloadOutlined />}
                    >
                      Refresh
                    </Button>
                  ) : (
                    ''
                  )}</>
              }
            />
          </div>
          {loading ||
            teamDataLoading ||
            !this.props.botUser._id ||
            this.props.skills.length === 0 ||
            this.props.botUser.team_id !== team.id ? (
            <Spin style={{ marginTop: '37vh', marginLeft: '0' }} />
          ) : (
            <div
              // style={{ overflow: 'scroll', padding: '0px 16px 24px 26px' }}
              style={{
                padding: '0px 24px 24px 24px',
                overflow: 'scroll',
              }}
            >
              {isGridWorkspace && isWorkspaceAdmin ? (
                <Tabs
                  className='mainBody'
                  // defaultActiveKey={'workspace_metrics'}
                  activeKey={this.state.activeKey}
                  onChange={this.handleTabChange}
                >
                  <TabPane tab='Workspace' key='workspace_metrics'>
                    {
                      <WorkspaceMetrics
                        sendData={this.getData}
                        onRef={(ref) => {
                          try {
                            this.setState({
                              updateDashBoard: ref
                                ? ref.getDashBoardMetrix
                                : '',
                            });
                          } catch (e) {
                            // eslint-disable-next-line no-console
                            console.error(e);
                          }
                        }}
                      />
                    }
                  </TabPane>
                  <TabPane tab='Grid' key='grid_metrics'>
                    <GridMetrics
                      sendData={this.getData}
                      sendInitialData={this.getGridInitialData}
                      onRef={(ref) => {
                        try {
                          this.setState({
                            updateGridMetrics: ref ? ref.updateGridMetrics : '',
                          });
                        } catch (e) {
                          // eslint-disable-next-line no-console
                          console.error(e);
                        }
                      }}
                    />
                  </TabPane>
                </Tabs>
              ) : (
                <div className='mainBody'>
                  <WorkspaceMetrics
                    sendData={this.getData}
                    onRef={(ref) => {
                      try {
                        this.setState({
                          updateDashBoard: ref ? ref.getDashBoardMetrix : '',
                        });
                      } catch (e) {
                        // eslint-disable-next-line no-console
                        console.error(e);
                      }
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </Layout>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  team: state.skills.team,
  botUser: state.common_reducer.tpuser,
  skills: state.skills.skills,
  isWorkspaceAdmin: state.common_reducer.isAdmin,
});

export default withRouter(connect(mapStateToProps, {})(Dashboard));
